import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import 'jquery';
import {BoService} from '../services/bo.service';
import {HttpErrorResponse} from '@angular/common/http';
import {nextFreeIdentifiant, deriveIdentifiant, identifiantEnConflit} from './identifiant.utils';
import {listesCochees} from './listes-cochees.utils';

declare var $: any;

@Component({
  selector: 'app-gerer-les-acces',
  templateUrl: './gerer-les-acces.component.html',
  styleUrls: ['./gerer-les-acces.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class GererLesAccesComponent implements OnInit {

  constructor(private boService: BoService) { }

  ngOnInit() {
    let t =this;
    $(document).ready(function(){
      // --- Data state : --------------------------------------------------------
      var dataKeys:any[] = [];           // flux Device (backend staff)
      var dataBoMembers:any[] = null;    // flux BO (backend staff bo)
      var dataAccess:any[] = [];         // liste unifiée pour rendu
      var dataAllLists;
      var getid='';
      var getType:'device'|'bo' = 'device';
      var dataIndex={aStaff:[]};
      var getindex=0;
      var maxitem=200;
      var maxScroll = 0;
      var cip=0;
      var passcrypt='';
      var dataSearch=[];
      var editingBoEmail='';
      var cus=['<span style="color:var(--ui-color-primary);background-color:var(--ui-color-alpha-teal-200-20)">','</span>'];
      //--------------------------------------------------------------------------
      //--- Initialisation globale : ---------------------------------------------
      $('.menubo,.headerbo').css({'display':'flex'});
      var darkMode='off';
      var contrastMode='off';
      var infoUser=JSON.parse(localStorage.getItem('infoUser'));
      if(infoUser.darkMode=='on'){darkMode='on'};
      if(infoUser.contrastMode=='on'){contrastMode='on'};
      var codeOrga='XXXXX';
      if(infoUser.codeOrganisateur){
        codeOrga=infoUser.codeOrganisateur;
      };
      var wiw=$(window).width();
      $('#htitsec').html('Mon équipe');
      $('#htitsec2').html('Gérer les accès');
      $('.menubs').attr('id','');$('.menubs-4').attr('id','actif1');
      $('.secmenu2bs').attr('id','');$('.4s1').attr('id','actif2');
      if(wiw>610){
        $('#htitsec,#htitsec2,#fles').css({'display':'inline'});
      }else{
        $('#htitsec2').css({'display':'inline'});
        $('#fles').css({'display':'none'});
      };
      $('.headerbo').css({'border-color':'var(--ui-color-border)','box-shadow':'none'});
      $(window).scroll(function(){
        var sw= $(this).scrollTop();
        if(sw>120){
          $('.headerbo').css({'border-color':'transparent','box-shadow':'var(--ui-shadow-sm)'});
        }else{
          $('.headerbo').css({'border-color':'var(--ui-color-border)','box-shadow':'none'});
        };
      });
      $(window).scrollTop(0);
      $('body').css({'overflow':'hidden'});
      //--------------------------------------------------------------------------
      // --- Helpers de présentation : -------------------------------------------
      function displayName(item:any):string {
        if(item._type==='device') return item.name || 'Accès sans nom';
        var n=((item.firstname||'')+' '+(item.lastname||'')).trim();
        return n || item.email || 'Sans nom';
      };
      function initials(item:any):string {
        var n=displayName(item);
        var p=n.split(' ');
        if(p.length>1 && p[0] && p[1]){
          return (p[0].slice(0,1)+p[1].slice(0,1)).toUpperCase();
        };
        return (n.slice(0,1)||'?').toUpperCase();
      };
      function buildDataAccess(){
        dataAccess = [];
        for(var i=0;i<dataKeys.length;i++){
          dataAccess.push(Object.assign({_type:'device'}, dataKeys[i]));
        };
        if(dataBoMembers){
          for(var j=0;j<dataBoMembers.length;j++){
            dataAccess.push(Object.assign({_type:'bo'}, dataBoMembers[j]));
          };
        };
        dataAccess.sort(function(a,b){
          if(a._type !== b._type) return a._type === 'device' ? -1 : 1;
          var na = (a._type === 'device' ? (a.name||'') : ((a.firstname||'')+' '+(a.lastname||'')).trim() || a.email || '').toLowerCase();
          var nb = (b._type === 'device' ? (b.name||'') : ((b.firstname||'')+' '+(b.lastname||'')).trim() || b.email || '').toLowerCase();
          return na.localeCompare(nb);
        });
      };
      function rerender(){
        buildDataAccess();
        loadItems(dataAccess);
        maxScroll = (($('.contitemga').height())-($('.contga').height()))-1;
      };
      //--------------------------------------------------------------------------
      // --- Initialisation contenu : --------------------------------------------
      $('.valCode,.valCodePop').html(codeOrga);
      dataAllLists=JSON.parse(localStorage.getItem('dataAllLists'));
      var dll=dataAllLists.length;
      // Compte des listes activées encore existantes (intersection dédupliquée avec dataAllLists).
      // enableList peut contenir des IDs de listes supprimées ou hors périmètre (filtre member),
      // que la longueur brute sur-comptait : on n'affiche que les listes réellement présentes.
      function countEnabledLists(ids){
        if(!ids || ids.length===0){ return 0; };
        var existingListIds = new Set(dataAllLists.map(function(l){ return l._id; }));
        return ids.filter(function(id,i,a){ return a.indexOf(id)===i && existingListIds.has(id); }).length;
      };
      Promise.all([
        t.boService.getAllKeys(),
        t.boService.getBoAccessList().catch(function(){ return []; })
      ]).then(function(results:any[]){
        var rawKeys = results[0] || [];
        dataBoMembers = results[1] || [];
        if(rawKeys.length>0){
          rawKeys = rawKeys.sort(function(a,b){return parseInt(a.index)-parseInt(b.index)});
          for(var i=0;i<rawKeys.length;i++){
            if(!rawKeys[i].enableList){ rawKeys[i].enableList=[]; };
            rawKeys[i].queue='';
            if(rawKeys[i].name==undefined){ rawKeys[i].name='Accès sans nom'; };
            if(rawKeys[i].modeout==undefined){ rawKeys[i].modeout=false; };
            if(rawKeys[i].definitiveout==undefined){ rawKeys[i].definitiveout=false; };
            if(rawKeys[i].isAdmin==undefined){ rawKeys[i].isAdmin=false; };
            dataIndex.aStaff.push({'id':rawKeys[i]._id,'index':rawKeys[i].index});
          };
        };
        dataKeys = rawKeys;
        rerender();
        if(dataAccess.length===0){ $('.txtnokey').fadeIn(0); };
        t.boService.screenMode(darkMode,contrastMode);
        $('.blocLoader').fadeOut(300);
      }).catch(function(error){
        t.boService.errorLoad(error);
      });
      function loadItems(list:any[]){
        $('.contitemga').html('');
        if(list.length>0){
          $('.txtnokey').fadeIn(0).fadeOut(0);
          for(var i=0;i<list.length;i++){
            var it = list[i];
            var lvk = initials(it);
            var dname = displayName(it);
            if(term){ dname = highlight(dname, term); };
            var bik = it.ban==true ? 'bankey' : '';
            var typeClass = 'type-'+it._type;
            var typeIcon = it._type === 'device'
              ? '<i class="fa-duotone fa-mobile-screen icTypeK"></i>'
              : '<i class="fa-duotone fa-desktop icTypeK"></i>';
            var listCount = '';
            // Au moins une liste associee : compteur en couleur d'accent.
            var nbLists = countEnabledLists(it.enableList);
            var nbClass = 'nblist' + (nbLists > 0 ? ' nblistOn' : '');
            if(it._type === 'device'){
              listCount = '<div class="'+nbClass+'">'+nbLists+'</div><div class="totnblist"> / '+dll+'</div>';
            }else{
              listCount = '<div class="'+nbClass+'">'+nbLists+'</div>';
            };
            var rowId = it._type === 'device' ? (it._id || '') : 'bo-'+it.email;
            $('.contitemga').append(
              '<div class="itemK '+bik+' '+typeClass+' index-'+i+'" id="'+rowId+'" data-type="'+it._type+'">'+
                '<div class="viK"><div class="vK">'+lvk+'</div><div class="banfilter"><i class="fas fa-eye-slash"></i></div></div>'+
                '<div class="nameK">'+typeIcon+' &nbsp;'+dname+'</div>'+
                '<div class="bulhK">'+listCount+'</div>'+
                '<div class="opK">'+
                  '<div class="icopd"><div class="icpd"></div><div class="icpd"></div><div class="icpd"></div></div>'+
                  '<div class="contopga">'+
                    '<i class="fas fa-clone imK imK1" title="Dupliquer"></i>'+
                    '<i class="fas fa-hand-paper imK imK2" title="Ban"></i>'+
                    '<i class="fas fa-trash imK imK3" title="Supprimer"></i>'+
                  '</div>'+
                '</div>'+
              '</div>'
            );
          };
        }else{
          if(!term){ $('.txtnokey').fadeIn(0); };
        };
      };
      function highlight(a,b){
        var splitMod=0;
        var termtxt='';
        var lis=a.split(b);
        if(lis.length==1){lis=a.split(b.toUpperCase());splitMod=1;};
        if(lis.length==1){lis=a.split(b.substr(0,1).toUpperCase()+b.substr(1));splitMod=2;};
        if(lis.length==1){lis=a.split(b.substr(0,1)+b.substr(1).toLowerCase());splitMod=3;};
        if(lis.length==1){lis=a.split(b.toLowerCase());splitMod=4;};
        if(lis.length>1){
          a='';
          for(var d=0;d<lis.length;d++){
            if(d!=(lis.length)-1){
              if(splitMod==1){termtxt=b.toUpperCase();
              }else if(splitMod==2){termtxt=b.substr(0,1).toUpperCase()+b.substr(1);
              }else if(splitMod==3){termtxt=b.substr(0,1)+b.substr(1).toLowerCase();
              }else if(splitMod==4){termtxt=b.toLowerCase();
              }else{termtxt=b;};
              a+=lis[d]+cus[0]+termtxt+cus[1];
            }else{
              a+=lis[d];
            };
          };
        };
        return a;
      };
      //--------------------------------------------------------------------------
      // --- Fonctions / actions : -----------------------------------------------
      var mx=0;
      var my=0;
      $('.contCode').on('mousemove touchmove',function(e){
        if(e.type=='mousemove'){
          mx=(e.pageX);
          my=(e.pageY);
        }else if(e.type=='touchmove'){
          mx=(e.originalEvent.touches[0].pageX);
          my=(e.originalEvent.touches[0].pageY);
        };
        $('.popInfoCode').css({'opacity':1,'left':mx+5, 'top': my+15});
      });
      $('.contCode').on('mouseout',function(){
        $('.popInfoCode').css({'opacity':0});
      });
      var cts=0;
      var s=0
      var v=0;
      var v1=0;
      var v2=0;
      var bb=0;
      var gg=0;
      var c=0;
      var hcs=0;
      var mis=0;
      var tis=0;
      var ois=0;
      var mcs=0;
      $('.contga').scroll(function(){
        cts=$(this).scrollTop();
        if(cts<0){ cts=0; }else if(cts>maxScroll){ cts=maxScroll; };
        if(s>270 || bb!=0){
          if(s>cts){
            if(bb==0 || bb==2){ bb=1; v=cts; v1=gg; };
            s=cts;
            if(gg<=0){ gg=0; }else{
              if(v1>270){ gg=270-(v-cts); }else{ gg=v1-(v-cts); };
            };
          }else{
            if(bb==1){ bb=2; v=cts; v2=gg; };
            s=cts;
            gg=(cts-v)+v2;
          };
        }else{ s=cts; gg=s; };
        c=gg*0.26;
        hcs=70-c; mis=16-(c*0.24); ois=1-(c*0.019); tis=1-(c*0.009); mcs=-40+(c*0.29);
        $('.contsearchResp').css({'height':hcs});
        $('.searchRespGa').css({'margin-top':mis,'opacity':ois});
        $('.searchicResp').css({'margin-top':mcs,'transform':'scale('+tis+')','opacity':ois});
        $('.cleanSearchResp').css({'margin-top':mcs,'transform':'scale('+tis+')'});
        if(term){ $('.cleanSearchResp').css({'opacity':ois}); };
        if(gg>=270){ $('.contsearchResp').css({'margin-top':'69px'}); }else{ $('.contsearchResp').css({'margin-top':'70px'}); };
      });
      $('.closeheadInfoGa').click(function(){
        $('.headerInfoGa').css({'opacity':'0.0','height':'0px'});
      });
      var r='r';
      var g=0;
      var cc=0;
      if(wiw<=610){
        $('.bloCont').click(function(){ $('.imK').css({'pointer-events':'none'}); });
        setTimeout(function(){ $('.imK').css({'pointer-events':'none'}); },1000);
        $('.contitemga').on('click','.menuK',function(e){
          e.stopPropagation();
          $('.imK').css({'pointer-events':'none'});
          var tim=$(this).children();
          setTimeout(function(){ tim.css({'pointer-events':'visible'}); },300);
        });
      };
      // --- Création : popup type choice (toujours) ---
      $('.btnaddKey').click(function(){
        $('.txtnoterm').fadeOut(0);
        $('.searchga').val('');
        term='';
        searchitemK();
        if(dataKeys.length>=maxitem){
          $('.popmax,.fdpopedit').fadeIn(500);
        }else{
          $('.popTypeAccess,.fdpopedit').fadeIn(500);
        };
      });
      // #451 — échec de création (dont 409 de course) : retirer l'entrée optimiste
      function rollbackOptimisticEntry(newData){
        cc--;
        var fi = dataKeys.findIndex(function(y){ return y.queue === newData.queue; });
        if(fi>=0){
          dataKeys.splice(fi,1);
          for(var i=0;i<dataKeys.length;i++){ dataKeys[i].index=i; };
          rerender();
        };
        $('.savestick').css({'right':'-260px'});
      };
      function createDeviceAccess(){
        $('.savestick').css({'right':'0px'});
        if(dataKeys.length==0){ $('.txtnokey').fadeOut(0); };
        var newData:any={
          name:'Accès sans nom', index:0,
          other: { 'index': 0, 'passlength': 6 },
          enableList: [], identifiant: nextFreeIdentifiant(dataKeys.map(function(k){ return k.identifiant; })),
          password:'000000', codeOrganisateur: codeOrga,
          modeout:false, definitiveout:false, ban:false, isAdmin:false
        };
        if(cc==0){g=0};
        r='r'+g; g++; cc++;
        newData.queue = r;
        dataKeys.splice(0,0,newData);
        for(var i=0;i<dataKeys.length;i++){dataKeys[i].index=i;};
        rerender();
        t.boService.createKey(newData).then(function(data){
          var idcurrent = data['id'];
          cc--;
          var fi = dataKeys.findIndex(function(y){ return y.queue === newData.queue; });
          if(fi>=0){
            dataKeys[fi]._id = idcurrent;
            dataKeys[fi].queue = '';
          };
          dataIndex.aStaff.splice(0,0,{'id':idcurrent,'index':0});
          for(var i=0;i<dataIndex.aStaff.length;i++){dataIndex.aStaff[i].index=i;};
          rerender();
          t.boService.editAllKeys(dataIndex).then(function(){
            $('.savestick').css({'right':'-260px'});
          }).catch(function(){});
        }).catch(function(){ rollbackOptimisticEntry(newData); });
      };
      $('.btnTypeDevice').click(function(){
        $('.popTypeAccess,.fdpopedit').fadeOut(300);
        setTimeout(createDeviceAccess, 350);
      });
      $('.btnTypeBo').click(function(){
        $('.popTypeAccess').fadeOut(300);
        // Ouvre la modale d'édition en mode BO create
        editingBoEmail = '';
        getType = 'bo';
        openEditModal(null);
      });
      // --- Dupliquer (Device only - pas de dup BO) ---
      $('.contitemga').on('click','.imK1', function(event){
        event.stopPropagation();
        var gt=$(this).closest('.itemK');
        var type=gt.attr('data-type');
        if(type!=='device') return;
        var accIndex=parseInt((gt.attr('class')).split('index-')[1]);
        var srcItem = dataAccess[accIndex];
        // retrouver l'index dans dataKeys
        var dkIndex = dataKeys.findIndex(function(k){ return k._id===srcItem._id; });
        if(dkIndex<0 || !dataKeys[dkIndex]._id) return;
        if(dataKeys.length>=maxitem){
          $('.popmax,.fdpopedit').fadeIn(500);
          return;
        };
        $('.savestick').css({'right':'0px'});
        var src = dataKeys[dkIndex];
        var newData:any={
          name:'Accès sans nom', index: src.index+1,
          other: { 'index': src.index+1, 'passlength': src.passlength },
          enableList: src.enableList, password: src.password,
          codeOrganisateur: codeOrga,
          modeout: src.modeout, definitiveout: src.definitiveout,
          ban: src.ban, isAdmin: src.isAdmin ?? false,
          passlength: src.passlength
        };
        // nom incrémenté
        var lastN = parseFloat(src.name.slice(-1));
        newData.name = isNaN(lastN) ? (src.name+' 2') : (src.name.slice(0,-1)+(lastN+1));
        newData.identifiant = deriveIdentifiant(src.identifiant, dataKeys.map(function(k){ return k.identifiant; }));
        if(src.password.length>20){ newData.other.password = src.password; };
        if(cc==0){g=0};
        r='r'+g; g++; cc++;
        newData.queue = r;
        dataKeys.splice(dkIndex+1, 0, newData);
        for(var i=0;i<dataKeys.length;i++){ dataKeys[i].index=i; };
        rerender();
        t.boService.createKey(newData).then(function(data){
          var idcurrent = data['id'];
          cc--;
          var fi = dataKeys.findIndex(function(y){ return y.queue === newData.queue; });
          if(fi>=0){
            dataKeys[fi]._id = idcurrent;
            dataKeys[fi].queue = '';
          };
          dataIndex.aStaff.splice(dkIndex+1, 0, {'id':idcurrent,'index':dkIndex+1});
          for(var i=0;i<dataIndex.aStaff.length;i++){dataIndex.aStaff[i].index=i};
          rerender();
          t.boService.editAllKeys(dataIndex).then(function(){
            $('.savestick').css({'right':'-260px'});
          }).catch(function(){});
        }).catch(function(){ rollbackOptimisticEntry(newData); });
      });
      // --- Ban ---
      $('.contitemga').on('click','.imK2',function(event){
        event.stopPropagation();
        var getpar=$(this).closest('.itemK');
        var type=getpar.attr('data-type');
        var accIndex=parseInt((getpar.attr('class')).split('index-')[1]);
        var it = dataAccess[accIndex];
        $('.savestick').css({'right':'0px'});
        if(type==='device'){
          var dkIndex = dataKeys.findIndex(function(k){ return k._id===it._id; });
          if(dkIndex<0) return;
          var src = dataKeys[dkIndex];
          src.ban = !src.ban;
          var newdata:any = {
            name: src.name, identifiant: src.identifiant, password: src.password,
            modeout: src.modeout, definitiveout: src.definitiveout, ban: src.ban
          };
          if(src.ban){ getpar.addClass('bankey'); getpar.find('.banfilter').css({'display':'flex'}); }
          else{ getpar.removeClass('bankey'); getpar.find('.banfilter').css({'display':'none'}); };
          t.boService.editKey(src._id, newdata).then(function(){
            $('.savestick').css({'right':'-260px'});
          }).catch(function(){});
        }else{
          var bmIndex = dataBoMembers.findIndex(function(m){ return m.email===it.email; });
          if(bmIndex<0) return;
          var newBan = !dataBoMembers[bmIndex].ban;
          dataBoMembers[bmIndex].ban = newBan;
          if(newBan){ getpar.addClass('bankey'); }else{ getpar.removeClass('bankey'); };
          t.boService.mergeBoAccess(it.email, {ban: newBan}).then(function(){
            $('.savestick').css({'right':'-260px'});
          }).catch(function(){});
        };
      });
      // --- Suppression ---
      $('.contitemga').on('click','.imK3',function(event){
        event.stopPropagation();
        var getpar=$(this).closest('.itemK');
        var type=getpar.attr('data-type');
        var accIndex=parseInt((getpar.attr('class')).split('index-')[1]);
        var it = dataAccess[accIndex];
        $('.savestick').css({'right':'0px'});
        getpar.css({'transform':'scale(0.5)','opacity':'0.0'});
        setTimeout(function(){
          if(type==='device'){
            var dkIndex = dataKeys.findIndex(function(k){ return k._id===it._id; });
            if(dkIndex<0) return;
            var idstaff = it._id;
            dataKeys.splice(dkIndex,1);
            for(var i=0;i<dataKeys.length;i++){dataKeys[i].index=i;};
            rerender();
            t.boService.removeKey(idstaff).then(function(){
              dataIndex.aStaff.splice(dkIndex,1);
              for(var i=0;i<dataIndex.aStaff.length;i++){dataIndex.aStaff[i].index=i};
              if(dataIndex.aStaff.length>0){
                t.boService.editAllKeys(dataIndex).then(function(){
                  $('.savestick').css({'right':'-260px'});
                }).catch(function(){});
              }else{
                $('.savestick').css({'right':'-260px'});
              };
            }).catch(function(){});
          }else{
            var bmIndex = dataBoMembers.findIndex(function(m){ return m.email===it.email; });
            if(bmIndex<0) return;
            dataBoMembers.splice(bmIndex,1);
            rerender();
            t.boService.deleteBoAccess(it.email).then(function(){
              $('.savestick').css({'right':'-260px'});
            }).catch(function(){});
          };
          if(dataAccess.length==0){ $('.txtnokey').fadeIn(0); };
        },200);
      });
      // --- Click item : ouvre la modale d'édition ---
      $('.contitemga').on('click','.itemK',function(){
        var type=$(this).attr('data-type');
        var accIndex=parseInt(($(this).attr('class')).split('index-')[1]);
        var it = dataAccess[accIndex];
        if(!it) return;
        getType = type as any;
        if(type==='device'){
          if(!it._id) return;
          getid = it._id;
          getindex = dataKeys.findIndex(function(k){ return k._id===it._id; });
          openEditModal(it);
        }else{
          editingBoEmail = it.email;
          openEditModal(it);
        };
      });
      function openEditModal(it:any){
        cip=0;
        inputchange=0;
        checkmod=0;
        $('.sectionDevice,.sectionBo').hide();
        if(getType==='device'){
          $('.titheadTxt').text("Configuration de l'accès");
          $('.sectionDevice').show();
          var src = dataKeys[getindex];
          $('.inName').val(src.name);
          $('.inIdentifier').val(src.identifiant);
          passcrypt='';
          var pl = src.passlength || 6;
          for(var i=0;i<pl;i++){ passcrypt+='0'; };
          $('.inPassword').val(passcrypt);
          if(src.modeout){ $('#inmok').addClass('inchon').prop('checked',true); $('.labmodoutdefK').removeClass('labmodoutdefKoff'); $('.contcheckopdefK').removeClass('contcheckopdefKoff'); }
          else{ $('#inmok').removeClass('inchon').prop('checked',false); $('.labmodoutdefK').addClass('labmodoutdefKoff'); $('.contcheckopdefK').addClass('contcheckopdefKoff'); };
          if(src.definitiveout){ $('#inmodefk').addClass('inchon').prop('checked',true); }else{ $('#inmodefk').removeClass('inchon').prop('checked',false); };
          if(src.isAdmin){ $('#inadmink').addClass('inchon').prop('checked',true); }else{ $('#inadmink').removeClass('inchon').prop('checked',false); };
          $('.inName,.inIdentifier,.inPassword').removeClass('signalinvide');
          // Listes de contrôle
          $('.contconflistK').show();
          $('.conflistK').html('');
          for(var i=0;i<dll;i++){
            var checkval='';
            for(var u=0;u<src.enableList.length;u++){
              if(src.enableList[u]==dataAllLists[i]._id){ checkval='checked'; };
            };
            var tplLK=dataAllLists[i].tpl.length;
            var txttar = tplLK<2 ? 'tarif' : 'tarifs';
            $('.conflistK').append('<div class="liLK" id="'+dataAllLists[i]._id+'" index="'+i+'" mod0="'+checkval+'" mod1="'+checkval+'"><div class="contCheckLK"><input type="checkbox" class="inCheckLK" id="inCheckLK'+dataAllLists[i]._id+'" '+checkval+'><label class="labCheckLK" for="inCheckLK'+dataAllLists[i]._id+'"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">'+dataAllLists[i].name+'</div><div class="tplLK">'+tplLK+' '+txttar+'</div></div>');
          };
          $('.countLK').html(countEnabledLists(src.enableList)+' / '+dll);
        }else{
          $('.titheadTxt').text("Configuration de l'accès BO");
          $('.sectionBo').show();
          var isEdit = !!it;
          $('.inEmailBo').val(isEdit ? it.email : '').prop('disabled', isEdit).removeClass('signalinvide');
          $('.inPasswordBo').val('').removeClass('signalinvide');
          $('.inFirstnameBo').val(isEdit ? (it.firstname||'') : '');
          $('.inLastnameBo').val(isEdit ? (it.lastname||'') : '');
          var enabledPages = isEdit ? (it.enablePages||[]) : ['tableau-de-bord','liste-des-participants','aide','support'];
          $('.liPageBoK').each(function(){
            var p=$(this).attr('data-page');
            var checked = enabledPages.indexOf(p)!==-1;
            $(this).attr('mod0', checked?'checked':'').attr('mod1', checked?'checked':'');
            $(this).find('.inCheckPageBo').prop('checked', checked);
          });
          // Listes de contrôle BO
          $('.contconflistK').show();
          $('.conflistK').html('');
          var enableList = isEdit ? (it.enableList||[]) : [];
          for(var i=0;i<dll;i++){
            var checkval = enableList.indexOf(dataAllLists[i]._id)!==-1 ? 'checked' : '';
            var tplLK=dataAllLists[i].tpl.length;
            var txttar = tplLK<2 ? 'tarif' : 'tarifs';
            $('.conflistK').append('<div class="liLK" id="'+dataAllLists[i]._id+'" index="'+i+'" mod0="'+checkval+'" mod1="'+checkval+'"><div class="contCheckLK"><input type="checkbox" class="inCheckLK" id="inCheckLK'+dataAllLists[i]._id+'" '+checkval+'><label class="labCheckLK" for="inCheckLK'+dataAllLists[i]._id+'"><i class="fas fa-check icCheckLK"></i></label></div><div class="nameLK">'+dataAllLists[i].name+'</div><div class="tplLK">'+tplLK+' '+txttar+'</div></div>');
          };
          $('.countLK').html(countEnabledLists(enableList)+' / '+dll);
        };
        $('.btnvalidedititemK').html('<i class="fas fa-save"></i> &nbsp; <span class="txtbtnvalidedititemK">Enregister</span>').addClass('btnvalidedititemKOff');
        $('.blocedititemK,.fdpopedit').fadeIn(500);
      };
      $('.contitemga').on('mousedown','.itemK',function(){
        $(this).css({'transition-duration':'0.0s'}).addClass('itemKmove');
      });
      $('.contitemga').on('mouseup','.itemK',function(){
        $(this).css({'transition-duration':'0.3s'}).removeClass('itemKmove');
      });
      // sortable désactivé : le tri est désormais déterministe (type + nom)
      $(".inName").change(function(){ $(this).removeClass('signalinvide').attr('placeholder','ex : Responsable de caisse'); });
      $(".inIdentifier").change(function(){ $(this).removeClass('signalinvide').attr('placeholder','Identifiant unique'); });
      $(".inPassword").focus(function(){ if(cip==0){ $(this).val(''); }; });
      $(".inPassword").focusout(function(){ if(cip==0){ $(this).val(passcrypt); }; });
      $(".inPassword").keyup(function(){ cip=1; });
      $(".inPassword").change(function(){ $(this).removeClass('signalinvide').attr('placeholder','Mot de passe'); });
      var inputchange=0;
      $('.inputformitemK').on('change keyup', function(){
        inputchange=1;
        $('.btnvalidedititemK').html('<i class="fas fa-save"></i> &nbsp; <span class="txtbtnvalidedititemK">Enregister</span>').removeClass('btnvalidedititemKOff');
      });
      $('#inmok').change(function(){
        inputchange=1;
        $('.btnvalidedititemK').removeClass('btnvalidedititemKOff');
        if($(this).hasClass('inchon')){
          $('#inmok').removeClass('inchon');
          $('.labmodoutdefK').addClass('labmodoutdefKoff');
          $('.contcheckopdefK').addClass('contcheckopdefKoff');
        }else{
          $('#inmok').addClass('inchon');
          $('.labmodoutdefK').removeClass('labmodoutdefKoff');
          $('.contcheckopdefK').removeClass('contcheckopdefKoff');
        };
      });
      $('#inmodefk').change(function(){
        inputchange=1;
        $('.btnvalidedititemK').removeClass('btnvalidedititemKOff');
        if($(this).hasClass('inchon')){ $('#inmodefk').removeClass('inchon'); }else{ $('#inmodefk').addClass('inchon'); };
      });
      $('#inadmink').change(function(){
        inputchange=1;
        $('.btnvalidedititemK').removeClass('btnvalidedititemKOff');
        if($(this).hasClass('inchon')){ $('#inadmink').removeClass('inchon'); }else{ $('#inadmink').addClass('inchon'); };
      });
      var openlist=0;
      $('.labelast').click(function(){
        if(openlist==0){
          openlist=1;
          $('.continopK').addClass('continopKhide');
          $('.contconflistK').addClass('contconflistKon');
          setTimeout(function(){ $('.inSearchListK').focus(); },300);
        }else{
          openlist=0;
          $('.continopK').removeClass('continopKhide');
          $('.contconflistK').removeClass('contconflistKon');
          $('.inSearchListK').val('');
          $('.conflistK .liLK').show();
        };
      });
      $('.inSearchListK').on('keyup',function(){
        var term=$(this).val().toString().toLowerCase();
        $('.conflistK .liLK').each(function(){
          var name=$(this).find('.nameLK').text().toLowerCase();
          if(!term||name.indexOf(term)!==-1){ $(this).show(); }else{ $(this).hide(); };
        });
      });
      var checkmod=0;
      $('.conflistK').on('click','.liLK',function(){
        var getparlist=$(this);
        if(getparlist.attr('mod1')=='checked'){
          getparlist.attr('mod1','');
          getparlist.find('.inCheckLK').prop('checked',false);
        }else{
          getparlist.attr('mod1','checked');
          getparlist.find('.inCheckLK').prop('checked',true);
        };
        var checkedListIds:string[]=listesCochees(document);
        $('.conflistK .liLK').each(function(){
          if($(this).attr('mod0')!=$(this).attr('mod1')){ checkmod=1; };
        });
        $('.countLK').html(countEnabledLists(checkedListIds)+' / '+dll);
        if(checkmod==1){
          $('.btnvalidedititemK').removeClass('btnvalidedititemKOff');
        }else if(inputchange==0){
          $('.btnvalidedititemK').addClass('btnvalidedititemKOff');
        };
      });
      // Toggle BO pages (même logique)
      $('.contPagesBoK').on('click','.liPageBoK',function(){
        var gp=$(this);
        if(gp.attr('mod1')=='checked'){ gp.attr('mod1',''); gp.find('.inCheckPageBo').prop('checked',false);
        }else{ gp.attr('mod1','checked'); gp.find('.inCheckPageBo').prop('checked',true); };
        inputchange=1;
        $('.btnvalidedititemK').removeClass('btnvalidedititemKOff');
      });
      // --- Save unifié ---
      var checlic9=0;
      $('.btnvalidedititemK').click(function(event){
        event.stopPropagation();
        if(checlic9!=0) return;
        checlic9=1;
        if(getType==='device'){
          saveDevice();
        }else{
          saveBo();
        };
      });
      function saveDevice(){
        var checregle=0;
        var re=/^[ t]*$/;
        if($('.inName').val()==''||$('.inName').val().match(re)){$('.inName').addClass('signalinvide').attr('placeholder','Ce champ est requis');checregle=1;};
        if($('.inIdentifier').val()==''||$('.inIdentifier').val().match(re)){$('.inIdentifier').addClass('signalinvide').attr('placeholder','Ce champ est requis');checregle=1;};
        if($('.inPassword').val()==''||$('.inPassword').val().match(re)){$('.inPassword').addClass('signalinvide').attr('placeholder','Ce champ est requis');checregle=1;};
        if(checregle==1){ checlic9=0; return; };
        var src = dataKeys[getindex];
        // #451 — un identifiant déjà porté par un autre accès casserait la résolution du login
        if(identifiantEnConflit(String($('.inIdentifier').val()), dataKeys, src._id)){
          $('.inIdentifier').addClass('signalinvide');
          $('.btnvalidedititemK').html('<i class="fa-solid fa-triangle-exclamation"></i> &nbsp; Cet identifiant est déjà utilisé');
          checlic9=0; return;
        };
        var newdata:any = { name:'', identifiant:'', modeout:false, definitiveout:false, isAdmin:false };
        $('.savestick').css({'right':'0px'});
        $('.btnvalidedititemK').html('Enregistrement en cours...');
        var oldIdentifiant = src.identifiant;
        src.name=$('.inName').val(); newdata.name=src.name;
        src.identifiant=$('.inIdentifier').val(); newdata.identifiant=src.identifiant;
        if(cip==1){
          src.password=$('.inPassword').val();
          src.passlength=$('.inPassword').val().length;
          newdata.password=src.password;
          newdata.passlength=src.passlength;
        }else{
          newdata.password=src.password;
        };
        src.modeout = $('#inmok').hasClass('inchon');
        newdata.modeout = src.modeout;
        src.definitiveout = $('#inmodefk').hasClass('inchon');
        newdata.definitiveout = src.definitiveout;
        src.isAdmin = $('#inadmink').hasClass('inchon');
        newdata.isAdmin = src.isAdmin;
        t.boService.editKey(src._id, newdata).then(function(){
          var tasks:Promise<any>[] = [];
          if(checkmod==1){
            var enableList:string[]=listesCochees(document);
            src.enableList = enableList;
            tasks.push(t.boService.editKeyList(src._id, {enableList: enableList}));
          };
          Promise.all(tasks).then(function(){
            $('.savestick').css({'right':'-260px'});
            $('.btnvalidedititemK').html('Enregistré &nbsp;<i class="far fa-check"></i>');
            $('.blocedititemK,.fdpopedit').fadeOut(500);
            openlist=0;
            $('.continopK').css({'opacity':1}).removeClass('continopKhide');
            $('.contconflistK').removeClass('contconflistKon');
            rerender();
            checlic9=0;
          }).catch(function(){ checlic9=0; });
        }).catch(function(e:HttpErrorResponse){
          // #451 — 409 serveur (course entre deux sessions) : restaurer l'état local
          src.identifiant = oldIdentifiant;
          var msg = (typeof e.error?.message === 'string') ? e.error.message : 'Erreur';
          if(e.status===409){ $('.inIdentifier').addClass('signalinvide'); };
          $('.btnvalidedititemK').html('<i class="fa-solid fa-triangle-exclamation"></i> &nbsp; '+msg);
          $('.savestick').css({'right':'-260px'});
          checlic9=0;
        });
      };
      function saveBo(){
        var email=$('.inEmailBo').val().toString().trim();
        var password=$('.inPasswordBo').val().toString();
        var re=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!editingBoEmail && !re.test(email)){ $('.inEmailBo').addClass('signalinvide'); checlic9=0; return; };
        if(!editingBoEmail && !password){ $('.inPasswordBo').addClass('signalinvide'); checlic9=0; return; };
        var enableList:string[]=listesCochees(document);
        var enablePages:string[]=[];
        $('.liPageBoK').each(function(){ if($(this).attr('mod1')=='checked') enablePages.push($(this).attr('data-page')); });
        var firstname=$('.inFirstnameBo').val();
        var lastname=$('.inLastnameBo').val();
        $('.savestick').css({'right':'0px'});
        $('.btnvalidedititemK').html('Enregistrement en cours...');
        var done = function(){
          $('.savestick').css({'right':'-260px'});
          $('.btnvalidedititemK').html('Enregistré &nbsp;<i class="far fa-check"></i>');
          t.boService.getBoAccessList().then(function(d:any){
            dataBoMembers = d || [];
            rerender();
          });
          setTimeout(function(){ $('.blocedititemK,.fdpopedit').fadeOut(500); },400);
          openlist=0;
          $('.continopK').css({'opacity':1}).removeClass('continopKhide');
          $('.contconflistK').removeClass('contconflistKon');
          checlic9=0;
        };
        var err = function(e:any){
          console.error('BO access save error:', e);
          var msg = 'Erreur';
          if (typeof e?.error?.message === 'string') msg = e.error.message;
          else if (typeof e?.error === 'string') msg = e.error;
          else if (e?.status) msg = 'Erreur ' + e.status;
          $('.btnvalidedititemK').html('<i class="fa-solid fa-triangle-exclamation"></i> &nbsp; '+msg);
          checlic9=0;
        };
        if(editingBoEmail){
          t.boService.mergeBoAccess(editingBoEmail, { enableList, enablePages, firstname, lastname }).then(done).catch(err);
        }else{
          t.boService.createBoAccess({ email, password, enableList, enablePages, firstname, lastname }).then(done).catch(err);
        };
      };
      $('.fdpopedit,.closepopitemK').click(function(){
        if(checlic9==0){
          $('.blocedititemK,.popTypeAccess,.popmax,.fdpopedit').fadeOut(500);
          openlist=0;
          $('.continopK').css({'opacity':1}).removeClass('continopKhide');
          $('.contconflistK').removeClass('contconflistKon');
        };
      });
      // --- Search ---
      var term='';
      function searchitemK(){
        if(term){
          $('.cleanSearch,.cleanSearchResp').css({'opacity':'1','pointer-events':'visible'});
          var filtered = dataAccess.filter(function(e){
            var n = e._type==='device' ? (e.name||'') : (((e.firstname||'')+' '+(e.lastname||'')).trim() || e.email || '');
            return n.search(term)!=-1
              || n.search(term.toUpperCase())!=-1
              || n.search(term.substr(0,1)+term.substr(1).toLowerCase())!=-1
              || n.search(term.substr(0,1).toUpperCase()+term.substr(1))!=-1
              || n.search(term.toLowerCase())!=-1;
          });
          if(filtered.length<=0){ $('.txtnoterm').fadeIn(0); }else{ $('.txtnoterm').fadeOut(0); };
          loadItems(filtered);
        }else{
          $('.txtnoterm').fadeOut(0);
          $('.cleanSearch,.cleanSearchResp').css({'opacity':'0','pointer-events':'none'});
          loadItems(dataAccess);
        };
      };
      $('.searchga').keyup(function(){ term=$(this).val().toString()||''; searchitemK(); });
      $('.cleanSearch').click(function(){ $('.searchga').val(''); term=''; $('.txtnoterm').fadeOut(0); searchitemK(); });
      $('.searchRespGa').keyup(function(){ term=$(this).val().toString()||''; searchitemK(); });
      $('.cleanSearchResp').click(function(){ $('.searchRespGa').val(''); term=''; $('.txtnoterm').fadeOut(0); searchitemK(); });
      $('.btnpopmax').click(function(){ $('.popmax,.fdpopedit').fadeOut(500); });
    });
  };
}
